import { createContext } from 'react';
import { ListSource } from '@eas/common-web';
import { AgendaSpecification } from '../../models';

export const SpecificationTableCtx = createContext<
  ListSource<AgendaSpecification>
>(undefined as any);
